import { Modal, ModalBody, ModalContent, ModalOverlay, useToast, } from '@chakra-ui/react';
import React from 'react';
import { Formik } from 'formik';
import { useCreateInspection } from '../../../../../services/api/generated/client';
import useGenericMutationUseCase from '../../../../../hooks/usecases/generic/useGenericMutationUseCase';
import SuspenseWrapper from '../../../../modules/SuspenseWrapper/SuspenseWrapper';
import AddInspectionForm from './AddInspectionForm';
import { localise } from '../../../../../services/lang/lang';
import StandardModalHeader from '../../../../modules/Modal/StandardModalHeader';
import { RenderIf } from '../../../../modules/RenderIf/RenderIf';
import { ErrorAwareAlertBox } from '../../../../modules/ErrorAwareAlertBox/ErrorAwareAlertBox';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import { manualAddressToAddress, } from '../../../../../services/ui/addresses';
import date from '../../../../../services/ui/date';
const AddInspectionModal = (props) => {
    const initialValues = {
        postcode: '',
        inspection_date: new Date(),
        assignee: undefined,
        address: undefined,
        manual_address: undefined,
    };
    const toast = useToast();
    const { execute, reset, isError, error } = useGenericMutationUseCase(useCreateInspection);
    const onSubmit = (values, helpers) => {
        const inspectionDate = date.server(values.inspection_date);
        const address = values.address ??
            (values.manual_address
                ? manualAddressToAddress(values.manual_address)
                : null);
        const data = {
            inspection_date: inspectionDate,
            assignee_id: values.assignee?.id ?? null,
            ...address,
        };
        execute({
            data,
        }, helpers, {
            onSuccess: (response) => {
                const inspection = unwrapModel(response);
                helpers.resetForm();
                toast({
                    title: localise('INSPECTION_FORM_SUCCESS'),
                    status: 'success',
                    isClosable: true,
                    duration: 1000,
                });
                props.onSuccess(inspection);
            },
        });
    };
    const onCloseModal = () => {
        reset();
        props.onClose();
    };
    return (React.createElement(Modal, { variant: "primary", isOpen: props.isOpen, onClose: onCloseModal },
        React.createElement(ModalOverlay, null),
        React.createElement(ModalContent, { tabIndex: -1 },
            React.createElement(StandardModalHeader, { title: localise('ADD_INSPECTION') }),
            React.createElement(RenderIf, { condition: isError },
                React.createElement(ErrorAwareAlertBox, { error: error, noun: localise('INSPECTION') })),
            React.createElement(ModalBody, null,
                React.createElement(SuspenseWrapper, null,
                    React.createElement(Formik, { initialValues: initialValues, onSubmit: onSubmit },
                        React.createElement(AddInspectionForm, { onClose: onCloseModal })))))));
};
export default AddInspectionModal;
